import React from 'react';
import TrustBar from '../TrustBar';
import HeroBlock from './HeroBlock';
import FeatureBlock from './FeatureBlock';
import CaseStudy from './CaseStudy';
import TemplatesBlock from './TemplatesBlock';
import CTABlock from './CTABlock';
import CTAPanel from './CTAPanel';
import PaymentTrustBar from './PaymentTrustBar';
import VideoEmbed from './VideoEmbed';
import EmbedPaperform from './EmbedPaperform';
import BlogContentBlock from './BlogContentBlock';
import ContentBlock from './ContentBlock';
import IntegrationsPromo from './IntegrationsPromo';
import IconFeatures from './IconFeatures';
import Faqs from './Faqs';
import Testimonials from './Testimonials';
import ProductHero from './ProductHero';
import CTABannerBlock from './CTABannerBlock';
import Pricing from './Pricing';
import Markdown from './Markdown';
import InlineImage from './InlineImage';
import InlineImageText from './InlineImageText';
import InlineTeam from './InlineTeam';
import FeatureList from './FeatureList';
import StatBlock from './StatBlock';
import SwissArmyKnife from './SwissArmyKnife';
import ColumnBlocks from './ColumnBlocks';
import Signature from './Signature';
import Button from './Button';
import ResourceCards from './ResourceCards';
import PartnerHeroBlock from './PartnerHeroBlock';
import TeamCarousel from './TeamCarousel';
import Table from './Table';
import CustomTool from './CustomTool';
import AISignature from './AISignature';
import Rotator from './Rotator';
export const BLOCK_MAP = {
  hero: HeroBlock,
  rotator: Rotator,
  feature: FeatureBlock,
  caseStudy: CaseStudy,
  templates: TemplatesBlock,
  cta: CTABlock,
  trust: TrustBar,
  ctaPanel: CTAPanel,
  paymentTrust: PaymentTrustBar,
  video: VideoEmbed,
  embedPaperform: EmbedPaperform,
  contentBlock: ContentBlock,
  blogContentBlock: BlogContentBlock,
  integrationsPromo: IntegrationsPromo,
  iconFeatures: IconFeatures,
  faqs: Faqs,
  testimonials: Testimonials,
  productHero: ProductHero,
  ctaBanner: CTABannerBlock,
  pricing: Pricing,
  markdown: Markdown,
  inlineImage: InlineImage,
  inlineImageText: InlineImageText,
  inlineTeam: InlineTeam,
  featureList: FeatureList,
  statBlock: StatBlock,
  swissArmyKnife: SwissArmyKnife,
  customTool: CustomTool,
  columnBlocks: ColumnBlocks,
  signature: Signature,
  aiSignature: AISignature,
  button: Button,
  resourceCards: ResourceCards,
  partnerHero: PartnerHeroBlock,
  teamCarousel: TeamCarousel,
  table: Table,
};

export const Blocks = BLOCK_MAP;
export default function PageBlocks({ type, block, isFirst }) {
  if (BLOCK_MAP[type]) {
    const Component = BLOCK_MAP[type];
    const isHero = type.toLowerCase().includes('hero');

    return (
      <section
        className={`block-${type}`}
        style={!isHero && isFirst ? { marginTop: 110 } : {}}
      >
        <Component {...(block[type] || {})} />
      </section>
    );
  }
  return null;
}
